import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

const useSessionExpiry = (setUser) => useEffect(() => {
  const id = api.interceptors.response.use((r) => r, (e) => {
    const url = e.config?.url || "";
    if (e.response?.status === 401 && !url.startsWith("/auth/")) {
      setUser((u) => {
        if (u) toast.error("Your session has ended. Please sign in again");
        return false;
      });
    }
    return Promise.reject(e);
  });
  return () => api.interceptors.response.eject(id);
}, [setUser]);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  useSessionExpiry(setUser);
  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const login = useCallback(async (username, password) => {
    const { data } = await api.post("/auth/login", { username, password });
    setUser(data);
    return data;
  }, []);
  const logout = useCallback(async () => {
    try { await api.post("/auth/logout"); } catch { /* session already gone */ }
    setUser(false);
  }, []);

  return <AuthContext.Provider value={{ user, setUser, login, logout }}>{children}</AuthContext.Provider>;
}
